import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Enso } from "@/components/Layout";
import { TipJar } from "@/components/TipJar";
import { SEO } from "@/components/SEO";

export default function Corner() {
  const [posts, setPosts] = useState([]);
  const [email, setEmail] = useState("");

  useEffect(() => { api.get("/corner").then((r) => setPosts(r.data)); }, []);

  const subscribe = async (e) => {
    e.preventDefault();
    try {
      await api.post("/emails/capture", { email, source: "bridgetts-corner" });
      toast.success("You'll hear about new posts first.");
      setEmail("");
    } catch (err) { toast.error(apiError(err)); }
  };

  return (
    <div>
      <SEO title="Bridgett's Corner" description="Notes from the founder of O.R.E.C — on community, care, and the quiet work of good people." />
      <section className="silk-hero">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 py-20 text-center">
          <div className="flex justify-center mb-5"><Enso size={44} /></div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-foreground mb-4">Bridgett's Corner</h1>
          <p className="text-muted-foreground max-w-md mx-auto leading-relaxed">Notes from the founder — on community, care, and the quiet work of good people. A sacred space; read gently.</p>
        </div>
      </section>

      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16 space-y-6" data-testid="corner-posts">
        {posts.map((p, i) => (
          <Link key={p.id} to={`/corner/${p.slug}`} data-testid={`corner-post-${p.slug}`}
            className="silk-card rounded-lg p-8 block fade-up" style={{ animationDelay: `${i * 0.07}s` }}>
            <p className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground mb-3">Bridgett's Corner</p>
            <h2 className="font-display text-3xl text-foreground mb-3">{p.title}</h2>
            <p className="text-muted-foreground leading-relaxed">{p.summary}</p>
          </Link>
        ))}
        {posts.length === 0 && <p className="text-center text-muted-foreground py-16">No posts yet — Bridgett is writing.</p>}
      </div>

      <div className="max-w-xl mx-auto px-5 pb-14 text-center" data-testid="support-bridgett">
        <h2 className="font-display text-lg md:text-2xl text-foreground mb-3">Support Bridgett ♥</h2>
        <p className="text-sm text-muted-foreground mb-6 leading-relaxed">
          O.R.E.C is a labour of love. If the Corner or this community has helped you, a small tip keeps the Ripple going.
        </p>
        <TipJar className="justify-center" />
      </div>

      <div className="max-w-xl mx-auto px-5 pb-24 text-center">
        <p className="text-sm text-muted-foreground mb-5">Be the first to know when Bridgett posts something new.</p>
        <form onSubmit={subscribe} className="flex flex-col sm:flex-row gap-3">
          <Input data-testid="corner-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="you@email.com" className="h-11 rounded-full bg-card/70" />
          <Button data-testid="corner-email-submit" type="submit" className="h-11 rounded-full px-7">Notify me</Button>
        </form>
      </div>
    </div>
  );
}
